import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TabState {
    tabControl: boolean;
}

const initialState: TabState = {
    tabControl: false
};

const tabSlice = createSlice({
    name: 'tab',
    initialState,
    reducers: {
        isTabFunc: (state, action: PayloadAction<boolean>) => {
            state.tabControl = action.payload;
        },

    },
});

export const { isTabFunc } = tabSlice.actions;

export default tabSlice.reducer;
